type BrandMarkProps = {
  readonly size?: number;
  readonly className?: string;
};

/** Shared leaf mark used on login, header, and favicon. */
export function BrandMark({ size = 22, className }: BrandMarkProps) {
  return (
    <span className={className ?? "nbs-brand-mark"} aria-hidden="true">
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M12 3c3.5 2 6 5 6 9 0 3.3-2.7 6-6 6s-6-2.7-6-6c0-4 2.5-7 6-9Z" fill="#bfe6cd" />
        <path
          d="M12 21V9m0 4 3-2m-3 5-2.6-1.7"
          stroke="#0f3d28"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
